import { memo, useCallback, useMemo } from "react";
import { useUnistyles } from "react-native-unistyles";
import { Text } from "@src/components";
import { Icon } from "@src/components/Icon";
import { View } from "@src/components";
import type { SiteUser } from "@src/features/settings/data/mock-sites";
import { List, type ListItem } from "./List";
import { StyleSheet } from "react-native-unistyles";

type CameraAccessListProps = {
  users: SiteUser[];
  cameraCountByUser: Map<string, number>;
  onPress: (userId: string) => void;
};

export const CameraAccessList = memo(({ users, cameraCountByUser, onPress }: CameraAccessListProps) => {
  const { theme } = useUnistyles();

  const items = useMemo(
    () =>
      users.map((user) => ({
        id: user.id,
        name: user.name,
        email: user.email,
        phoneNumber: user.phoneNumber,
      })),
    [users],
  );

  const renderRight = useCallback(
    (item: ListItem) => {
      const count = cameraCountByUser.get(item.id) ?? 0;
      return (
        <View flexDirection="row" alignItems="center" gap="xs">
          <Text textStyle="xs/regular" style={{ color: theme.colors.textSecondary }}>
            {count} {count === 1 ? "camera" : "cameras"}
          </Text>
          <Icon name="chevronRight" color={theme.colors.textSecondary} />
        </View>
      );
    },
    [theme, cameraCountByUser],
  );

  if (items.length === 0) {
    return (
      <View style={styles.emptyStateContainer}>
        <Text textStyle="sm/regular" color="textMuted" textAlign="center">
          No users found
        </Text>
      </View>
    );
  }
  return <List items={items} onItemPress={onPress} renderRight={renderRight} />;
});

const styles = StyleSheet.create((theme) => ({
  emptyStateContainer: {
    paddingVertical: theme.spacing["5xl"],
  },
}));
